import { useState, useEffect } from 'react'

import { GlobalIntl } from './GlobalIntl'
import { SupportedLocales } from './types'
import { loadLocaleData } from './loadLocaleData'

export function useLocale(locale: SupportedLocales) {
    const [messages, setMessages] = useState({})
    GlobalIntl.locale = locale

    useEffect(() => {
        loadLocaleData(locale).then(messages => {
            setMessages(messages)
            GlobalIntl.messages = messages
        })
    }, [locale])

    return messages
}
